/* eslint-disable @typescript-eslint/no-explicit-any */

export interface Integration {
  pageState: PageState
  integrations: IntegrationDetails[]
}

export enum PageState {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export interface IntegrationDetails {
  name: string
  description: string
  image: string
  serverValue: string
  docsLink: string
  configurationOptions: ConfigurationOption[]
  iverifyOptions: ConfigurationOption[]
  required?: boolean
  min?: number
  max?: number
  format?: string
  category: string
  authorization?: IntegrationAuthorization
  actions?: IntegrationAction[]
  isActive: boolean
}

export interface IntegrationAuthorization {
  type: string
  provider: string
  urlType?: string
  url?: string
}

export interface IntegrationAction {
  label: string
  type: string
  icon?: string
  urlType?: string
  url?: string
}

export interface ConfigurationOption {
  label: string
  type: string
  serverValue: string
  placeholder: string
  options: PortalOptionObject[]
  value: any
  required?: boolean
  minLength?: number
  maxLength?: number
  format?: string
  secret?: boolean
  radioOptions?: RadioOption[]
  readOnly?: boolean
  hidden?: boolean
}

export interface PortalOptionObject {
  label: string
  subLabel?: string
  value: string
  type?: string
  placeholder?: string
  required?: boolean
  minLength?: number
  maxLength?: number
  format?: string
  secret?: boolean
  radioOptions?: RadioOption[]
}

export interface RadioOption {
  label: string
  subLabel?: string
  value: string
  type?: string
  placeholder?: string
  required?: boolean
  minLength?: number
  maxLength?: number
  format?: string
  secret?: boolean
}

export interface UpdateIntegrationPayload {
  integrationValues: string
  integrationServerValue: string
}

export interface IntegrationValue {
  serverValue: string
  value: string
}

export interface DeleteIntegrationPayload {
  integrationServerValue: string
}
